import { createContext, useContext, useState } from 'react';

const LangContext = createContext();

const T = {
  fr: {
    dashboard: "Tableau de bord",
    priceRequests: "Demandes de prix",
    productionTracking: "Gestion expédition",
    myProjects: "Mes projets",
    projectsInProgress: "Projets en cours",
    urgent: "Urgents",
    completed: "Terminés",
    total: "Total",
    upcomingDeadlines: "Prochaines échéances",
    respond: "Répondre",
    modifyOffer: "Modifier mon offre",
    priceTTC: "Prix TTC",
    currency: "Devise",
    deadline: "Délai",
    observations: "Observations",
    submit: "Envoyer",
    update: "Mettre à jour",
    cancel: "Annuler",
    client: "Client",
    description: "Description",
    quantity: "Quantité",
    desiredDeadline: "Délai souhaité",
    attachments: "Pièces jointes",
    responses: "réponse(s)",
    noRequests: "Aucune demande de prix",
    projectName: "Nom du projet",
    estimatedEndDate: "Date de fin estimée",
    trackingNumber: "N° de suivi",
    carrier: "Transporteur",
    status: "Statut",
    notes: "Notes",
    inProduction: "En production",
    shipped: "Expédié",
    delivered: "Livré",
    addShipment: "Nouvelle production",
    noShipments: "Aucune expédition",
    yourOffer: "Votre offre",
    offersReceived: "offre(s) reçue(s)",
    open: "Ouverte",
    closed: "Fermée",
    welcome: "Bienvenue",
    subPortal: "Espace sous-traitant",
    save: "Enregistrer",
    updateProgress: "Mettre à jour",
    negotiations: "Négociations",
    negotiationsEmpty: "Aucune négociation en cours",
    negotiationsIntro: "Retrouvez ici toutes vos négociations de prix en cours (demandes de prix et commandes GO PRODUCTION).",
    negotiationTypePrice: "Négociation de prix",
    negotiationTypeOrder: "Négociation de commande",
    lastMessage: "Dernier message",
    counterOffer: "Contre-proposition",
    initialOffer: "Offre initiale",
    openNegotiation: "Ouvrir",
    waitingReply: "En attente de réponse",
    yourTurn: "À vous de répondre",
  },
  en: {
    dashboard: "Dashboard",
    priceRequests: "Price Requests",
    productionTracking: "Shipment management",
    myProjects: "My Projects",
    projectsInProgress: "Projects in progress",
    urgent: "Urgent",
    completed: "Completed",
    total: "Total",
    upcomingDeadlines: "Upcoming deadlines",
    respond: "Respond",
    modifyOffer: "Modify offer",
    priceTTC: "Price (incl. tax)",
    currency: "Currency",
    deadline: "Deadline",
    observations: "Observations",
    submit: "Submit",
    update: "Update",
    cancel: "Cancel",
    client: "Client",
    description: "Description",
    quantity: "Quantity",
    desiredDeadline: "Desired deadline",
    attachments: "Attachments",
    responses: "response(s)",
    noRequests: "No price requests",
    projectName: "Project name",
    estimatedEndDate: "Estimated end date",
    trackingNumber: "Tracking number",
    carrier: "Carrier",
    status: "Status",
    notes: "Notes",
    inProduction: "In production",
    shipped: "Shipped",
    delivered: "Delivered",
    addShipment: "New production",
    noShipments: "No shipments",
    yourOffer: "Your offer",
    offersReceived: "offer(s) received",
    open: "Open",
    closed: "Closed",
    welcome: "Welcome",
    subPortal: "Subcontractor Portal",
    save: "Save",
    updateProgress: "Update",
    negotiations: "Negotiations",
    negotiationsEmpty: "No negotiations in progress",
    negotiationsIntro: "All your ongoing price negotiations (price requests and GO PRODUCTION orders) in one place.",
    negotiationTypePrice: "Price negotiation",
    negotiationTypeOrder: "Order negotiation",
    lastMessage: "Last message",
    counterOffer: "Counter-offer",
    initialOffer: "Initial offer",
    openNegotiation: "Open",
    waitingReply: "Awaiting reply",
    yourTurn: "Your turn to reply",
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState('fr');
  const t = (key) => T[lang]?.[key] || T.fr[key] || key;
  const toggleLang = () => setLang(l => l === 'fr' ? 'en' : 'fr');
  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
